import { useMemo } from "react";
import { PaymentsModalType } from "entities/shared/subscriptionModel";
import { subscriptionStore } from "entities/Subscription";
import { useAppDispatch, useAppSelector } from "shared/lib/redux";
import { useTranslation } from "shared/localization/localization";
import { Link } from "shared/ui/Button";
import { CloseIcon } from "shared/ui/Icons";
import { Portal } from "shared/ui/Portal";
import { PRICING_PAGE_AIR_TRACKING_URL } from "shared/utils/url.utils";
import styles from "./PaymentsModal.module.scss";

import { PaymentsModalBottomDescription } from "../PaymentsModalBottomDescription";
import { PaymentsModalTitle } from "../PaymentsModalTitle";
import { PaymentsModalTopDescription } from "../PaymentsModalTopDescription";

const PaymentsModalBase: RFC = ({ children }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const activePaymentModal = useAppSelector(subscriptionStore.selectors.activePaymentModal);

  const paymentsButtonText = useMemo(() => {
    if (activePaymentModal === PaymentsModalType.PAY) {
      return t("Pricing plans");
    }
    return t("Upgrade your plan");
  }, [activePaymentModal]);

  const handleClose = () => {
    dispatch(subscriptionStore.actions.setActivePaymentModal(null));
  };

  return (
    <Portal className={styles.modal} closePopup={handleClose}>
      <div className={styles.content}>
        <CloseIcon onClick={handleClose} className={styles.closeButton} />
        {children}
        {/* <Link target="_blank" className={styles.link} href={PRICING_PAGE_AIR_TRACKING_URL}>
          {paymentsButtonText}
        </Link> */}
      </div>
    </Portal>
  );
};

type CompoundPaymentsModal = typeof PaymentsModalBase & {
  Title: typeof PaymentsModalTitle;
  TopDescription: typeof PaymentsModalTopDescription;
  BottomDescription: typeof PaymentsModalBottomDescription;
};

const Modal = PaymentsModalBase as CompoundPaymentsModal;
Modal.displayName = "Modal";

Modal.Title = PaymentsModalTitle;
Modal.TopDescription = PaymentsModalTopDescription;
Modal.BottomDescription = PaymentsModalBottomDescription;

export const AirPaymentsModal: RFC = () => {
  return (
    <Modal>
      <Modal.Title />
      <Modal.TopDescription />
      <Modal.BottomDescription />
    </Modal>
  );
};
